import create from 'zustand';

interface IConversationWidgetStore {
  openWidget: boolean;
  updateOpenWidget(args: boolean): void;
}

const openConversationWidget = create<IConversationWidgetStore>((set) => ({
  openWidget: false,
  updateOpenWidget: (value: boolean) => set({ openWidget: value }),
}));

export default openConversationWidget;
